export default __webpack_public_path__ + "static/media/icon_in_progress.1bcff752.svg";